import React from 'react';
import ReactDOM from 'react-dom/client'; // Import do 'react-dom/client' para React 18
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import StoreContextProvider from './context/StoreContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <StoreContextProvider>
      <Router>
        <App />
      </Router>
    </StoreContextProvider>
  </React.StrictMode>
);
